export default "__VITE_ASSET__Cm9oPOG7__"